<template src="./UserRegister.html" />

<script>
import mixins from "@/Mixins"

export default {
  mixins: [mixins],
  name: "user-register",
  data() {
    return {
      name: null,
      email: null,
      invalidFields: {
        name: false,
        email: false,
      },
      specificFieldsMessage: {
        name: "Campo obrigatório",
        email: "Campo obrigatório",
      },
      fieldsWarning: false,
    };
  },
  methods: {
    adminUserRegister() {
      this.axios.post(
        `${this.$store.state.filooServer}user-register`,
        {
          email: this.email,
          name: this.name,
          type: "ADMIN",
          password: this.password,
        },
        { headers: { Authorization: this.$session.get("bearer") } }
      )
        .then((response) => { 
          if (response.status === 201) {
            this.showNotifySuccess("Sucesso", "Usuário registrado!", 5000)

            setTimeout(() => {
              this.$router.push("manage-permissions")
            }, 4500);
          }
        })
        .catch((error) => {
          console.error({ location: "adminUserRegister", error }) 
          this.showNotifyWarning(
            error.status === 412
              ? "E-mail já cadastrado. Tente novamente como outro e-mail!"
              : "Não foi possível criar um novo usuário. Tente novamente mais tarde!",
            5000
          )
        })
    },
    validateFields() {
      if (!this.name) {
        this.invalidFields.name = true
        this.specificFieldsMessage.name = "Campo obrigatório"
      } else if (!this.testFullName(this.name)) {
        this.invalidFields.name = true
        this.specificFieldsMessage.name = "Insira o nome completo"
      }

      if (!this.email) {
        this.invalidFields.email = true
        this.specificFieldsMessage.email = "Campo obrigatório"
      } else if (!this.validateEmail(this.email)) {
        this.invalidFields.email = true
        this.specificFieldsMessage.email = "E-mail inválido"
      }

      if (Object.values(this.invalidFields).some((val) => val)) {
        this.fieldsWarning = true
      } else {
        this.adminUserRegister()
      }
    }
  }
};
</script>

<style lang="scss" src="./UserRegister.scss" scoped />
